import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-flodIcon",
  "use": "icon-flodIcon-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-flodIcon\"><rect x=\"3\" y=\"3\" width=\"16\" height=\"2\" /><rect x=\"9\" y=\"7\" width=\"10\" height=\"2\" /><rect x=\"9\" y=\"11\" width=\"10\" height=\"2\" /><rect x=\"3\" y=\"16\" width=\"16\" height=\"2\" /><polygon points=\"3 13 3 8 7 10.5 3 13\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol